import { z } from 'zod';

export const AiCareDocumentTreatmentDetailsSchema = z.object({
  treatment: z.string().nullish(),
  plan: z.string().nullish(),
  expectedEndDate: z.string().nullish(),
  other: z.string().nullish(),
});

export type AiCareDocumentTreatmentDetails = z.infer<
  typeof AiCareDocumentTreatmentDetailsSchema
>;
